function Hooks(ajaxUrls){
	// binds
	this.onSetFieldConditional = this.onSetFieldConditional.bind(this);

	this.hooks = {
		'setFieldConditional' : [this.onSetFieldConditional],
		'getFieldValue' : [this.getFieldValue],
		'afterFieldValidation' : [this.autoFillInstallerData, this.autoFillAddress],
		'formSubmitted' : [this.formSubmittedTagManager, this.updateProgressBar],
		'formSubmitMessageDisplayed' : [this.resetWarrantyForm],
		'searchDistributorSubmitted' : [this.searchDistributorSubmittedTagManager],
		'boilerSelectorAdviceGenerated' : [this.boilerSelectorAdviceGeneratedTagManager],
		'boilerEnergylabelDownloaded' : [this.boilerEnergylabelDownloadedTagManager],
	};
}

// To do: returnData should be passed to te next function in line. There are more modifications needed to make this work.
Hooks.prototype.triggerAction = function(hookName, parameters){
	if(this.hooks[hookName]){
		let returnData = null;
		for(let i=0;i<this.hooks[hookName].length;i++){
			returnData = this.hooks[hookName][i].apply(this, parameters);
		}
		return returnData;
	}
};

Hooks.prototype.onSetFieldConditional = function(form, formField){
	if(!form || !formField || formField.data.type !== 'attendees') {
		return;
	}

	let courseId = null;

	for(let i=0;i<form.formFields.length;i++){
		if(! form.formFields[i].isHidden() && form.formFields[i].data.type === 'course'){
			courseId = form.formFields[i].getValue();
			break;
		}
	}

	if(!courseId){
		return;
	}

	formField.setStatus('loading');

	const totalCourseAttendeesRequest = new XMLHttpRequest();
	totalCourseAttendeesRequest.addEventListener('readystatechange', function(event){
		if(event.target.readyState != 4) return;
		if(event.target.status != 200 && event.target.status != 304) {
			console.log('HTTP error ' + event.target.status);
			return;
		}

		const attendeeNumbers = JSON.parse(event.target.responseText);

		this.setStatus('reset');

		const freePlaces = attendeeNumbers.maxAttendees - attendeeNumbers.totalAttendees;

		const formElements = formField.getFormElements();

		if(formElements[0].nodeName === 'SELECT' && freePlaces > 0){
			const selectElement = formElements[0];

			for(let i=selectElement.childNodes.length-1;i>=0;i--){
				if(selectElement.childNodes[i].value){
					selectElement.removeChild(selectElement.childNodes[i]);
				}
			}

			for(let i=1;i<=freePlaces;i++){
				let optionElement = document.createElement('option');
				optionElement.appendChild(document.createTextNode(i));
				optionElement.setAttribute('value', i);
				selectElement.appendChild(optionElement);
			}
		}
	}.bind(formField));

	let postData = 'course_id=' + courseId;

	totalCourseAttendeesRequest.open('POST', ajax_url_get_couse_attendees);//ajax_url_get_couse_attendees is injected by WordPress for the combined javascript file
	totalCourseAttendeesRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	totalCourseAttendeesRequest.send(postData);
};

Hooks.prototype.getFieldValue = function(formField, elements, asString){
	// To do: better to check for number inputs in all elements
	if(!formField || formField.data.type !== 'documents') {
		return;
	}

	// check if there is a number input type (for amount field)
	let foundNumber = false;
	for(let i=0;i<elements.length;i++){
		if(elements[i].getAttribute('type') == 'number'){
			foundNumber = true;
			break;
		}
	}

	if(!foundNumber){
		return;
	}

	let values = [];

	for(let i=0;i<elements.length;i++){
		switch(elements[i].getAttribute('type')){
			case 'checkbox':
				let value = {
					'id': elements[i].value
				};
				break;
			case 'number':
				value.amount = elements[i].value;
				values.push(value);
				break;
		}
	}

	if(asString){
		let valuesAsString = [];

		values.forEach((value) => {
			valuesAsString.push(value.id + ';' + value.amount);
		});

		return valuesAsString.join(',');
	}

	return values;
};


/**
 * Hook function for autofilling installer data.
 *
 * @param Form Form object.
 * @param FormField FormField object. This FormField triggered the action.
 * @param object validation response with all info about the validation for this field.
 * @author Niels Riekert
 */

Hooks.prototype.autoFillInstallerData = function(form, formField, validation){
	// To do: hardcoding on field name, this should be in a plugin or the functionality should be included in the forms class/functionality
	if(formField.data.name != 'installateur-postcode' && formField.data.name != 'installateur-huisnummer' || !validation.validated){
		return;
	}

	form.formFields.forEach(field => {
		if((formField.data.name != 'installateur-huisnummer' && field.data.name == 'installateur-huisnummer') || field.data.name == 'installateur-bedrijfsnaam' || field.data.name == 'installateur-plaats' || field.data.name == 'installateur-website'){
			field.setStatus('loading');
		}
	});

	const getInstallersRequest = new XMLHttpRequest();
	getInstallersRequest.addEventListener('readystatechange', function(event){
		if(event.target.readyState != 4) return;
		if(event.target.status != 200 && event.target.status != 304) {
			console.log('HTTP error ' + event.target.status);
			return;
		}

		const installers = JSON.parse(event.target.responseText);

		if( installers.length != 1 ) {
			form.formFields.forEach(field => {
				switch(field.data.name){
					case 'installateur-huisnummer':
						field.setStatus('reset');
						field.setEnabled();
						if(formField.data.name == 'installateur-postcode'){
							//field.setValue('');
							//field.setStatus('focus');
						}
						break;
					case 'installateur-bedrijfsnaam':
					case 'installateur-straat':
					case 'installateur-plaats':
					case 'installateur-telefoon':
					case 'installateur-email':
					case 'installateur-website':
						field.setStatus('reset');
						if(field.isStatus('disabled') && ! field.isAutoFilled()){
							field.setValue('');
						}
						field.setLabelStatus(false, false);
						break;
				}
			});
		}
		else if( installers.length == 1 ) {
			const foundInstaller = installers[0];
			form.formFields.forEach(field => {
				switch(field.data.name){
					case 'installateur-postcode':
						if(!field.isStatus('validated')){
							field.setStatus('reset');
						}
						break;
					case 'installateur-huisnummer':
						field.setValue(foundInstaller.address.houseNumber);
						if(!field.isStatus('validated')){
							field.setStatus('reset');
						}
						if(formField.data.name == 'installateur-postcode'){
							field.setDisabled();
							field.verifyInput();
						}
						if(foundInstaller.address.houseNumber){
							field.setLabelStatus(false, true);
						}
						break;
					case 'installateur-bedrijfsnaam':
						if(field.isStatus('disabled')){
							field.setValue(foundInstaller.name);
						}
						field.setStatus('reset');
						if(foundInstaller.name){
							field.setLabelStatus(false, true);
						}
						break;
					case 'installateur-straat':
						if(field.isStatus('disabled')){
							field.setValue(foundInstaller.address.street);
						}
						field.setStatus('reset');
						if(foundInstaller.address.street){
							field.setLabelStatus(false, true);
						}
						break;
					case 'installateur-plaats':
						if(field.isStatus('disabled')){
							field.setValue(foundInstaller.city);
						}
						field.setStatus('reset');
						if(foundInstaller.city){
							field.setLabelStatus(false, true);
						}
						break;
					case 'installateur-telefoon':
						if(field.isStatus('disabled')){
							field.setValue(foundInstaller.phone);
						}
						field.setStatus('reset');
						if(foundInstaller.phone){
							field.setLabelStatus(false, true);
						}
						break;
					case 'installateur-email':
						if(field.isStatus('disabled')){
							field.setValue(foundInstaller.email);
						}
						field.setStatus('reset');
						if(foundInstaller.email){
							field.setLabelStatus(false, true);
						}
						break;
					case 'installateur-website':
						if(field.isStatus('disabled')){
							field.setValue(foundInstaller.website);
						}
						field.setStatus('reset');
						if(foundInstaller.website){
							field.setLabelStatus(false, true);
						}
						break;
				}
			});
		}
	});

	let postData = 'publish-status=draft';
	let postDataKeys = '';
	let postDataValues = '';

	form.formFields.forEach(field => {
		if(field.data.name == 'installateur-postcode'){
			if(postDataKeys){
				postDataKeys += ',';
			}
			postDataKeys += 'postcode';
			if(postDataValues){
				postDataValues += ',';
			}
			postDataValues += field.getValue();
		}

		if(field.data.name == 'installateur-huisnummer' && field.getValue()){
			if(postDataKeys){
				postDataKeys += ',';
			}
			postDataKeys += 'house_number';
			if(postDataValues){
				postDataValues += ',';
			}
			postDataValues += field.getValue();
		}
	});

	postData += '&distributor-types=installer';
	postData += '&search-keys=' + postDataKeys + '&search-values=' + postDataValues;

	getInstallersRequest.open('POST', ajax_url_get_distributors);// ajax_url_get_distributors is injected by WordPress for the combined javascript file
	getInstallersRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	getInstallersRequest.send(postData);
};


/**
 * Hook function for autofilling address data.
 *
 * @param Form Form object.
 * @param FormField FormField object. This FormField triggered the action.
 * @param object validation response with all info about the validation for this field.
 * @author Niels Riekert
 */

Hooks.prototype.autoFillAddress = function(form, formField, validation){
	if(typeof ig_current_locale === 'undefined'){
		return;
	}

	switch(ig_current_locale){
		case 'nl_NL':
			if(typeof ajax_url_validate_address_dutch === 'undefined') {
				return;
			}
			break;
	}

	if(!formField.data.group || formField.data.group.type != 'address' || !validation.validated){
		return;
	}

	if(formField.data.type != 'postcode' && formField.data.type != 'house-number') {
		return;
	}

	const addressFormFields = form.getFormFieldsByGroup(formField.data.group.name);

	for(let i=0;i<addressFormFields.length;i++) {
		if((addressFormFields[i].data.type == 'postcode' || addressFormFields[i].data.type == 'house-number') && (!addressFormFields[i].isValidated() || addressFormFields[i].isDisabled())) {
			return;
		}
	}

	// set loading status for disabled fields
	let disabledFieldCount = 0;
	addressFormFields.forEach(field => {
		if(field.data.type != 'postcode' && field.data.type != 'house-number'){
			if(field.isDisabled()){
				field.setStatus('loading');
				disabledFieldCount ++;
			}
		}
		field.removeAutoFilled();
	});

	// if there are no disabled fieds an api request is not needed
	if(disabledFieldCount == 0){
		return;
	}

	// start api request
	const validateAddressDutchRequest = new XMLHttpRequest();
	validateAddressDutchRequest.addEventListener('readystatechange', function(event){
		if(event.target.readyState != 4) return;
		if(event.target.status != 200 && event.target.status != 304) {
			console.log('HTTP error ' + event.target.status);
			return;
		}

		let response = JSON.parse(event.target.responseText);

		// To do: dit zou op http status code moeten
		if(response.error && response.error == 'Rate limit exceeded.'){
			addressFormFields.forEach(field => {
				field.setStatus('reset');
				field.setEnabled();
			});
			return;
		}

		if(Array.isArray(response)){
			response = response[0];
		}

		addressFormFields.forEach(field => {
			if(!field.isDisabled()){
				return;
			}

			field.setStatus('reset');
			if(response[field.data.type]){
				field.setLabelStatus(false, true);
				field.setValue(response[field.data.type]);
				field.setValidated();
				field.setAutoFilled();
			}
		});
	});

	let postData = '';
	addressFormFields.forEach(field => {
		if(field.data.type == 'postcode' || field.data.type == 'house-number'){
			if(postData){
				postData += '&';
			}
			postData += field.data.type + '=' + field.getValue();
		}
	});

	validateAddressDutchRequest.open('POST', ajax_url_validate_address_dutch);// ajax_url_validate_address_dutch is injected by WordPress for the combined javascript file
	validateAddressDutchRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	validateAddressDutchRequest.send(postData);
};


/**
 * Hook function for adding form submission data in the dataLayer from Google Tag Manager.
 *
 * @param Form form object.
 * @param object submitResponse object with all info about the submit result.
 * @author Niels Riekert
 */

Hooks.prototype.formSubmittedTagManager = function(form, submitResponse){
	if(typeof dataLayer === 'undefined' || !Array.isArray(dataLayer)){
		return;
	}

	const event = (submitResponse.formValidated === true) ? 'form-validated' : 'form-error';

	// To do: when the form redirects it could be so that the event won't be saved in time by GA.
	dataLayer.push({
		'event' : event,
		'formName' : form.name,
		'formId' : form.formId,
		'formValidations' : submitResponse.validations
	});
};


/**
 * Hook function for updating progress bar above form.
 *
 * @param Form form object.
 * @param object submitResponse object with all info about the submit result.
 * @author Niels Riekert
 */

Hooks.prototype.updateProgressBar = function(form, submitResponse){
	if(submitResponse.formValidated !== true){
		return;
	}

	const progressBarContainerElement = document.getElementById('progress-bar-container-' + form.formId);
	const progressBarElement = document.getElementById('progress-bar-bar-' + form.formId);

	if(!progressBarContainerElement || !progressBarElement){
		return;
	}

	let currentValue = progressBarContainerElement.getAttribute('data-value');
	let maxValue = progressBarContainerElement.getAttribute('data-max');

	currentValue ++;
	progressBarContainerElement.setAttribute('data-value', currentValue);

	progressBarElement.setAttribute('style', 'width: ' + (currentValue / maxValue * 100) + '%;');

	let template = progressBarElement.getAttribute('data-template');

	template = template.replace('{value}', currentValue);
	template = template.replace('{max}', maxValue);

	while(progressBarElement.firstChild){
		progressBarElement.removeChild(progressBarElement.firstChild);
	}

	progressBarElement.appendChild(document.createTextNode(template));
};


/**
 * Hook function for resetting a Warranty registration Form.
 *
 * @param Form form object.
 * @param object messageElement html element with the message.
 * @author Niels Riekert
 */

Hooks.prototype.resetWarrantyForm = function(form, messageElement){
	let buttonElements = messageElement.getElementsByClassName('js-button-reset-warranty-form');

	if(!buttonElements || buttonElements.length < 1){
		return;
	}

	buttonElements = [].slice.call(buttonElements);

	buttonElements.forEach(button => {
		button.addEventListener('click', function(event){
			event.preventDefault();

			let resetField = true;
			form.formFields.forEach((formField) => {
				if(resetField){
					formField.reset();
				}

				if(formField.data.type == 'section'){
					resetField = false;
				}
			});

			messageElement.parentNode.removeChild(messageElement);
			form.setStatus('visible');
		});
	});
}


/**
 * Hook function for adding search installer submit data in the dataLayer from Google Tag Manager.
 *
 * @param string input
 * @author Niels Riekert
 */

Hooks.prototype.searchDistributorSubmittedTagManager = function(input){
	if(typeof dataLayer === 'undefined' || !Array.isArray(dataLayer)){
		return;
	}

	dataLayer.push({
		'event' : 'search-installer',
		'searchInstallerInput' : input
	});
};


/**
 * Hook function for adding boiler selector advice data in the dataLayer from Google Tag Manager.
 *
 * @author Niels Riekert
 */

Hooks.prototype.boilerSelectorAdviceGeneratedTagManager = function(products){
	if(typeof dataLayer === 'undefined' || !Array.isArray(dataLayer)){
		return;
	}

	let productTitles = [];

	if(Array.isArray(products)){
		products.forEach((product) => {
			productTitles.push(product.title);
		});
	}

	dataLayer.push({
		'event' : 'boiler-selector-advice',
		'boilerSelectorFilteredProducts': productTitles.join(',')
	});
};


/**
 * Hook function for adding boiler energylabel download data in the dataLayer from Google Tag Manager.
 *
 * @author Niels Riekert
 */

Hooks.prototype.boilerEnergylabelDownloadedTagManager = function(productId, productTitle, thermostatClass, thermostatTitle){
	if(typeof dataLayer === 'undefined' || !Array.isArray(dataLayer)){
		return;
	}

	dataLayer.push({
		'event' : 'boiler-energylabel-download',
		'productId': productId,
		'productTitle': productTitle,
		'thermostatClass': thermostatClass,
		'thermostatTitle': thermostatTitle,
	});
}

export default Hooks;